import { routerReducer as nextRouterReducer } from '@ngrx/router-store';
import type { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';

import { ENVIRONMENT } from 'src/configs/environment/environment';

import { AppStateFeature } from './app-state-feature.enum';
import type { OwccAppState } from './app.state';
import { mbccReducer } from './mbcc/mbcc.reducer';
import { routerReducer } from './router/router.reducer';

export const reducers: ActionReducerMap<OwccAppState> = {
  [AppStateFeature.Mbcc]: mbccReducer,
  [AppStateFeature.Router]: routerReducer,
  [AppStateFeature.NextRouter]: nextRouterReducer
};

export const metaReducers: MetaReducer<OwccAppState>[] = ENVIRONMENT.production ? [] : [storeFreeze];
